import React from "react";
import { css, keyframes } from "emotion";

const svgStyle = css({
  display: "block",
  marginLeft: -30,
  marginRight: 25,
  width: 48
});

const pathStyle = css({
  stroke: " #48a2ff",
  strokeWidth: 8,
  strokeDasharray: 1000,
  strokeDashoffset: 0
});

const circleKeyframes = keyframes({
  "0%": {
    strokeDashoffset: 1000
  },

  "100%": {
    strokeDashoffset: 0
  }
});

const checkKeyframes = keyframes({
  "0%": {
    strokeDashoffset: -100
  },

  "100%": {
    strokeDashoffset: 900
  }
});

const circleStyle = animate =>
  css(pathStyle, {
    animation: animate ? `${circleKeyframes} 0.9s ease-in-out forwards` : "none"
  });

const checkStyle = animate =>
  css(pathStyle, {
    strokeDashoffset: animate ? -100 : 900,
    animation: animate
      ? `${checkKeyframes} 0.9s 0.35s ease-in-out forwards`
      : "none"
  });

const Checkmark = ({ animate }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 130.2 130.2"
    className={svgStyle}
  >
    <circle
      className={circleStyle(animate)}
      fill="none"
      strokeMiterlimit="10"
      cx="65.1"
      cy="65.1"
      r="62.1"
    />
    <polyline
      className={checkStyle(animate)}
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      points="100.2,40.2 51.5,88.8 29.8,67.5 "
    />
  </svg>
);

export default Checkmark;
